module.exports = __webpack_public_path__ + "static/img/avallach.af2a14e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/neutral/avallach.png
// module id = g6NM
// module chunks = 0